import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export const StyledLoadingWrapper = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'center',
}))`
  height: 100%;
`;
